import React from "react"

import ThreeWorld from "./threeworld"
import IntroView from "./introview"
import SliderView from "./sliderview"

import "./calculator.css";

class Calculator extends React.Component {

	constructor(props) {
        super(props); 
    }

	componentDidMount() {
		var OSName="Unknown OS";
        if (navigator.appVersion.indexOf("Win")!=-1) OSName="Windows";
        if (navigator.appVersion.indexOf("Mac")!=-1) OSName="MacOS";
        if (navigator.appVersion.indexOf("X11")!=-1) OSName="UNIX";
        if (navigator.appVersion.indexOf("Linux")!=-1) OSName="Linux";

        if(OSName == "Windows"){
            this.el.classList.add("windows");
        }
	}

	sliderCallback = (sliderValue) => {
        this.threeWorld.onSlider(sliderValue);
    }

    threeCallback = () => {
        this.introView.animateIn();
    }

    introCallback = (val) => {
        var that = this;
    	this.introView.animateOut();
    	this.sliderView.animateIn();
        if(val == 0){
            this.sliderView.setState({scale:20000});
            this.sliderView.setState({scaleIndex:0});
        }
        else{
            this.sliderView.setState({scale:100});
            this.sliderView.setState({scaleIndex:1});
        }

        setTimeout(function(){
            that.sliderView.updateWaterCanvas();
            that.sliderView.updateLandCanvas();
            that.sliderView.updateAirCanvas();
        });

        this.el.classList.add("stage2");
    }

	render() {
		return (
        	<div id="impact-calculator" ref={element => this.el = element}>
        		<ThreeWorld callback={this.threeCallback} ref={element => this.threeWorld = element}/>
        		<IntroView callback={this.introCallback} ref={element => this.introView = element}/>
        		<SliderView callback={this.sliderCallback} ref={element => this.sliderView = element} />
        	</div>
      	);
	}
}

export default Calculator;
